export default "__VITE_ASSET__DdAo6M7r__"